import React, {Suspense, useContext} from 'react';
import menuItems from './items';
import { Box, Divider, ListItem, Typography } from '@mui/material';
import Icon, { IconType } from '../../../components/Icon/Icon';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { SidebarContext } from '../../../contexts/SidebarContext';
import theme from '../../../theme';
import LanguageSelector from '../../../components/LanguageSelector/LanguageSelector';
import {useTranslation} from 'react-i18next';

interface SidebarMenuItemProps {
    href: string;
    title: string;
    icon: IconType;
}

function SidebarMenu() {
    const { sidebarToggle } = useContext(SidebarContext);
    const { t } = useTranslation();

    const SidebarMenuItem = ({ href, title, icon }: SidebarMenuItemProps) => {
        const router = useLocation();
        const navigate = useNavigate();
        const active = href ? router.pathname.toLowerCase().includes(href) : false;

        return (
            <ListItem
                disableGutters
                sx={{
                    display: 'flex',
                    mb: 0.5,
                    py: 0,
                    px: 0,
                }}
            >
                <Box
                    onClick={() => navigate(href, { replace: true })}
                    sx={{
                        height: '54px',
                        display: 'flex',
                        alignItems: 'center',
                        width: '100%',
                        padding: '20px',
                        cursor: 'pointer',
                        borderLeft: active ? '4px solid black' : '4px solid transparent',
                        '&:hover': {
                            backgroundColor: '#F0F2F0',
                        },
                        [theme.breakpoints.down('sm')]: {
                            padding: '14px',
                        },
                    }}
                >
                    {sidebarToggle ? (
                        <Typography variant="body1">{title}</Typography>
                    ) : (
                        <Icon icon={icon} styles={{padding: icon == 'house' ? '14%': '0'}}/>
                    )}
                </Box>
            </ListItem>
        );
    };

    return (
        <>
            <Box sx={{ flexGrow: 1 }}>
                {menuItems.map(item => (
                    <SidebarMenuItem
                        key={item.name}
                        href={item.link}
                        title={t(item.name)}
                        icon={item.icon}
                    />
                ))}
            </Box>
            <Box sx={{paddingBottom: '20px', [theme.breakpoints.down('md')]: {paddingBottom: '5px'}}}>
                <Suspense fallback={''}>
                    <LanguageSelector isSidebarSelector={true} />
                </Suspense>
            </Box>
            <Divider sx={{ borderColor: '#E3E7E4' }} />
        </>
    );
}

export default SidebarMenu;
